import type { SVGProps } from 'react';

export const PanelRightIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.9996 2.66653H4.99968C2.97702 2.66653 1.33302 4.31053 1.33302 6.33319V17.6665C1.33302 19.6892 2.97702 21.3332 4.99968 21.3332H18.9996C21.0223 21.3332 22.6663 19.6892 22.6663 17.6665V6.33319C22.6663 4.31053 21.0223 2.66653 18.9996 2.66653ZM7.33301 16.3332C7.33301 16.8852 6.88501 17.3332 6.33301 17.3332C5.78101 17.3332 5.33301 16.8852 5.33301 16.3332V7.66652C5.33301 7.11452 5.78101 6.66652 6.33301 6.66652C6.88501 6.66652 7.33301 7.11452 7.33301 7.66652V16.3332ZM18.373 12.7065L15.373 15.7065C15.1783 15.9012 14.9223 15.9998 14.6663 15.9998C14.4103 15.9998 14.1543 15.9025 13.9597 15.7065C13.569 15.3158 13.569 14.6825 13.9597 14.2918L15.253 12.9985H9.66634C9.11434 12.9985 8.66634 12.5505 8.66634 11.9985C8.66634 11.4465 9.11434 10.9985 9.66634 10.9985H15.2517L13.9583 9.70518C13.5677 9.31452 13.5677 8.68119 13.9583 8.29052C14.349 7.89985 14.9823 7.89985 15.373 8.29052L18.373 11.2905C18.7636 11.6812 18.7636 12.3158 18.373 12.7065Z"
      fill="currentColor"
    />
  </svg>
);
